import { useState } from "react";
import { InputText, DescriptionBody, TitleBody, ButtonPrimary } from "../../../common";
import { FromContainer } from "./style";

interface FormCreateWorkoutProps {
    onSubmit: (name: string) => void;
    loading: boolean;
}

export const FormCreateWorkout: React.FC<FormCreateWorkoutProps> = ({ onSubmit, loading }) => {
    const [name, setName] = useState<string>("");

    const onClickSave = () => {
        onSubmit(name);
    }

    return (
        <FromContainer>
            <TitleBody>Criar treino</TitleBody>
            <DescriptionBody margintop="5px" marginbottom="30px">
            Descreva o objetivo do treino.
            </DescriptionBody>
            <InputText
                label="Digite um nome:"
                placeholder="Ex: treino de tempo de reação"
                onChange={(e) => setName(e.target.value)}
                value={name}
                color="#000" />
            <ButtonPrimary
                margintop="20px"
                width="100%"
                disabled={!name}
                loading={loading}
                onClick={onClickSave}
                marginbottom="0px">Criar e continuar</ButtonPrimary>
        </FromContainer>
    )
}